import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Translate} from "../../../components/util/translation.util";
import {RuleType} from "rc-field-form/lib/interface";

export type Constraint = {
    max?: number,
    required?: boolean,
    type?: RuleType,
    message: React.ReactElement,
    pattern?: RegExp,
    min?: number
}

export const MaxLengthConstraint = ( max = 255, message = 'This value is too long. It should have {{ limit }} character or less.|This value is too long. It should have {{ limit }} characters or less.', domain = TranslationDomainEnum.VALIDATORS ): Constraint => {
    return {
        max,
        message: <Translate message={ message } domain={ domain } params={{ limit: max.toString() }} />
    }
}

export const MinLengthConstraint = ( min = 1, message = 'This value is too short. It should have {{ limit }} character or more.|This value is too short. It should have {{ limit }} characters or more.', domain = TranslationDomainEnum.VALIDATORS ): Constraint => {
    return {
        min,
        message: <Translate message={ message } domain={ domain } params={{ limit: min.toString() }} />
    }
}

export const EmailConstraint = ( message = 'Please enter a valid email address.', domain = TranslationDomainEnum.VALIDATORS ): Constraint => {
    return {
        type: "email",
        message: <Translate message={ message } domain={ domain } />
    }
}

export const RegExpConstraint = (pattern: RegExp, message = 'This value is not valid.', domain = TranslationDomainEnum.VALIDATORS ): Constraint => {
    return {
        pattern: new RegExp(pattern),
        message: <Translate message={ message } domain={ domain } />
    }
}

export const RequiredConstraint = ( required = true, message = 'This value should not be blank.', domain = TranslationDomainEnum.VALIDATORS ): Constraint => {
    return {
        required,
        message: <Translate message={ message } domain={ domain } />
    }
}

export const MinNumberConstraint = ( min = 1, message = 'This value should be greater than or equal to {{ compared_value }}.', domain = TranslationDomainEnum.VALIDATORS ): Constraint => {
    return {
        type: 'number',
        min,
        message: <Translate message={ message } domain={ domain } params={{
            compared_value: min.toString()
        }}/>
    }
}

export const RepeatedConstraint = (firstField = '', message = 'The values do not match.', domain = TranslationDomainEnum.VALIDATORS) => {
    return ({ getFieldValue }: any) => ({
        validator(_: any, value: any) {
            if (!value || getFieldValue(firstField) === value) {
                return Promise.resolve();
            }
            return Promise.reject(<Translate message={ message } domain={ domain } />);
        },
    });
}